export const rights = [
    {
        pageName: `VerifyLabInvestigationAudit`,
        pageDescription: `Audit: Verify Lab Investigation`
    },
    {
        pageName: `VerifyRadiologyInvestigationAudit`,
        pageDescription: `Audit: Verify Radiology Investigation`
    },
    {
        pageName: `VerifyTheatreProcedureAudit`,
        pageDescription: `Audit: Verify Theatre Procedure`
    },
    {
        pageName: `VerifyOtherConsultantService`,
        pageDescription: `Audit: Verify Other Consultant Services`
    },
    {
        pageName: `DefinePaymentLabInvestigationAudit`,
        pageDescription: `Audit: Define Payment Lab Investigation`
    },
    {
        pageName: `DefinePaymentRadiologyInvestigationAudit`,
        pageDescription: `Audit: Define Payment Radiology Investigation`
    },
    {
        pageName: `DefinePaymentTheatreProcedureAudit`,
        pageDescription: `Audit: Define Payment Theatre Procedure`
    },
    {
        pageName: `DefineOtherConsultantServices`,
        pageDescription: `Audit: Define Payment Other Consultant Services`
    },
    {
        pageName: `ApproveLabInvestigationAudit`,
        pageDescription: `Audit: Approve Lab Investigation`
    },
    {
        pageName: `ApproveRadiologyInvestigationAudit`,
        pageDescription: `Audit: Approve Radiology Investigation`
    },
    {
        pageName: `ApproveTheatreProcedureAudit`,
        pageDescription: `Audit: Approve Theatre Procedure`
    },
    {
        pageName: `ApproveOtherConsultantServices`,
        pageDescription: `Audit: Approve Other Consultant Services`
    },
    {
        pageName: `CancelConsultantVoucher`,
        pageDescription: `Vouchers: Cancel Consultant Voucher`
    }, {
        pageName: `ReverseConsultantVoucher`,
        pageDescription: `Vouchers: Reverse Consultant Voucher`
    },
    {
        pageName: `AddSurveillanceInfo`,
        pageDescription: `Audit: Add Session & Surveillance Info`
    },
    {
        pageName: `AddHeadCountInfo`,
        pageDescription: `Audit: Add Session & Headcount Info`
    },
    {
        pageName: `AllowPayLater`,
        pageDescription: `Accounts: Allow Pay Later for service`,
    },
    {
        pageName: `UpdateProcedureDateForNotes`,
        pageDescription: `Theatre: Update date For Procedure Notes`,
    },
    {
        pageName: `UpdateDateDoneForLabInvestigation`,
        pageDescription: `Theatre: Update date done For Lab Investigation`,
    },
    {
        pageName: `UpdateDateDoneForRadiologyInvestigation`,
        pageDescription: `Theatre: Update date done For Radiology Investigation`,
    },
    {
        pageName: `ReverseDischarge`,
        pageDescription: `Admissions: Reverse Discharge`,
    },{
        pageName: `ViewPrintMedicalReport`,
        pageDescription: `Medical File: View and Print Medical Report`,
    },
    {
        pageName: `ConvertPatientToSpecial`,
        pageDescription: `Admissions: Convert To Special`,
    },
    {
        pageName: `AdminEditMedicalFile`,
        pageDescription: `Admin: Edit Medical File`,
    },
    {
        pageName: `AdminEditAdministrationDetails`,
        pageDescription: `T Sheet: Edit Administration Details`,
    },
    {
        pageName: `AdminReverseInvestigation`,
        pageDescription: `Admin: Reverse Investigation`,
    },
    {
        pageName: `DisableDischargeDate`,
        pageDescription: `System: Disable Edit Discharge Dates`,
    },
    {
        pageName: `ValidateVisitWithDocuments`,
        pageDescription: `System: Visit With Documents`,
    },
    {
        pageName: `ApproveInventoryOrders`,
        pageDescription: `Inventory: Approve Orders`,
    },
    {
        pageName: `FulfillInventoryOrders`,
        pageDescription: `Inventory: Fulfill Inventory Orders`,
    },
    {
        pageName: `PrintInterimBill`,
        pageDescription: `Billing: Print Interim Bill`,
    },{
        pageName: `RecordLabResults`,
        pageDescription: `Lab: Record Lab Results`,
    }
    ,{
        pageName: `MedicalFileOther`,
        pageDescription: `MedicalFile: Other Prescriptions and Investigations`,
    },{
        pageName: `ApproveConsultants`,
        pageDescription: `Consultants: Approve Consultants`,
    },
    {
        pageName: `ReversePostedInvoice`,
        pageDescription: `Suppliers: Reverse Posted Invoice`,
    },
    {
        pageName: `ViewSpecialPatients`,
        pageDescription: `Patients: View Special Patients`,
    },
    {
        pageName: `AddSpecialPatients`,
        pageDescription: `Patients: Add Special Patients`,
    },{
        pageName: `EditPatientBillItem`,
        pageDescription: `Billing: Edit Bill Item`,
    },
    {
        pageName: `ApproveDischargeWithBilling`,
        pageDescription: `Patients: Approve Discharge With Billing`,
    },
    {
        pageName: `ViewDateOnInvoicePrintOut`,
        pageDescription: `Reports: View Date On Invoice Print Out`,
    },{
        pageName: `ViewItemDateOnInvoicePrintOut`,
        pageDescription: `Reports: View Item Date On Invoice Print Out`,
    }, {
        pageName: `ViewDateOfAdmissionandDischargeOnInvoicePrintOut`,
        pageDescription: `Reports: View Date Of Admission and Discharge On Invoice Print Out`,
    },
    {
        pageName: `DashboardStatistics`,
        pageDescription: `Dashboard: View System Analytics`,
    }
    ,{
        pageName: `ViewPOSSalesReport`,
        pageDescription: `Accounts Reports: View POS Sales Report`,
    }
    ,{
        pageName: `ViewLPOSignatories`,
        pageDescription: `LPO: View LPO Signatories`,
    }  ,{
        pageName: `ViewInvoiceSignatories`,
        pageDescription: `Billing: View Invoice Signatories`,
    } ,{
        pageName: `GatePassSignatoris`,
        pageDescription: `Admssion: View Billing and Finance Signatories on Gate pass`,
    }  ,{
        pageName: `ApproveSupplierPayment`,
        pageDescription: `Finance: Approve Supplier Payment`,
    },
    {
        pageName: `HRAccess`,
        pageDescription: `HR Access`,
    }, {
        pageName: `AccessOldData`,
        pageDescription: `Access Old Data and Reports`,
    },
    {
        pageName: `CancelWardandPharmacyCharges`,
        pageDescription: `Billing: Cancel Ward and Pharmacy Charges`,
    },{
        pageName: `ReceivecashOrmpesa`,
        pageDescription: `Accounts: Receive Cash Or Mpesa Payment`,
    },{
        pageName: `Receivecash`,
        pageDescription: `Accounts: Receive Cash Payment`,
    }
    ,{
        pageName: `Receivempesa`,
        pageDescription: `Accounts: Receive Mpesa Payment`,
    },{
        pageName: `Receivebank`,
        pageDescription: `Accounts: Receive Bank Payment`,
    }
    ,{
        pageName: `RequestWaiver`,
        pageDescription: `Accounts: Request for Waiver`,
    }
    ,{
        pageName: `ReceiveInsuranceInvoice`,
        pageDescription: `Accounts: Receive Insurance Invoices`,
    }
    ,{
        pageName: `ExportExpenses`,
        pageDescription: `Finance: Export Expenses`,
    },{
        pageName: `AccessPhoneNo`,
        pageDescription: `Configs: View Patient Phone Number and National ID`,
    },{
        pageName: `ApproveSystemUsers`,
        pageDescription: `Admin: Approve System Users/Employee`,
    },{
        pageName: `DisplayPatientSignatureOnInvoice`,
        pageDescription: `Billing: Display Patient Signature On Invoice`,
    },{
        pageName: `EditPatientDiagnosis`,
        pageDescription: `Medical File: Admin Edit Patient Diagnosis`,
    },{
        pageName: `AllocateDeposit`,
        pageDescription: `Accounts: Allocate Deposit`,
    },
    {
        pageName: `DisplayDrugReceivedOnDischargeSummary`,
        pageDescription: `Inpatient: Display Drug Received On Discharge Summary`,
    },
    {
        pageName: `DisplayPrintedByOnDischargeSummary`,
        pageDescription: `Inpatient: Display Printed By User On Discharge Summary`,
    }
    , {
        pageName: `ViewPendingLabInvestigationsCounts`,
        pageDescription: `Admin: View Pending Lab Investigation Count`,
    } , {
        pageName: `ViewPendingRadiologyInvestigationsCounts`,
        pageDescription: `Admin: View Pending Radilogy Investigation Count`,
    },
    
    
];
